const actions = {
  CREATE_EVENTS_BEGIN: 'CREATE_EVENTS_BEGIN',
  CREATE_EVENTS: 'CREATE_EVENTS',
  CREATE_EVENTS_ERR: 'CREATE_EVENTS_ERR',
  CREATE_EVENTS_EMPTY: 'CREATE_EVENTS_EMPTY',

  FETCH_ALL_EVENTS_LIST_BEGIN: 'FETCH_ALL_EVENTS_LIST_BEGIN',
  FETCH_ALL_EVENTS_LIST: 'FETCH_ALL_EVENTS_LIST',
  FETCH_ALL_EVENTS_LIST_ERR: 'FETCH_ALL_EVENTS_LIST_ERR',

  FETCH_EVENTS_DETAILS_BEGIN: 'FETCH_EVENTS_DETAILS_BEGIN',
  FETCH_EVENTS_DETAILS: 'FETCH_EVENTS_DETAILS',
  FETCH_EVENTS_DETAILS_ERR: 'FETCH_EVENTS_DETAILS_ERR',

  UPDATE_EVENTS_DETAILS_BEGIN: 'UPDATE_EVENTS_DETAILS_BEGIN',
  UPDATE_EVENTS_DETAILS: 'UPDATE_EVENTS_DETAILS',
  UPDATE_EVENTS_DETAILS_ERR: 'UPDATE_EVENTS_DETAILS_ERR',
  UPDATE_EVENTS_DETAILS_EMPTY: 'UPDATE_EVENTS_DETAILS_EMPTY',

  createEventsBegin: () => {
    return {
      type: actions.CREATE_EVENTS_BEGIN,
    };
  },

  createEvents: (data) => {
    return {
      type: actions.CREATE_EVENTS,
      data,
    };
  },
  createEventsErr: (err) => {
    return {
      type: actions.CREATE_EVENTS_ERR,
      err,
    };
  },
  createEventsEmpty: (err) => {
    return {
      type: actions.CREATE_EVENTS_EMPTY,
      err,
    };
  },

  fetchAllEventsListBegin: () => {
    return {
      type: actions.FETCH_ALL_EVENTS_LIST_BEGIN,
    };
  },

  fetchAllEventsList: (data) => {
    return {
      type: actions.FETCH_ALL_EVENTS_LIST,
      data,
    };
  },
  fetchAllEventsListErr: (err) => {
    return {
      type: actions.FETCH_ALL_EVENTS_LIST_ERR,
      err,
    };
  },

  fetchEventsDetailsBegin: () => {
    return {
      type: actions.FETCH_EVENTS_DETAILS_BEGIN,
    };
  },

  fetchEventsDetails: (data) => {
    return {
      type: actions.FETCH_EVENTS_DETAILS,
      data,
    };
  },
  fetchEventsDetailsErr: (err) => {
    return {
      type: actions.FETCH_EVENTS_DETAILS_ERR,
      err,
    };
  },

  updateEventsDetails: (data) => {
    return {
      type: actions.UPDATE_EVENTS_DETAILS,
      data,
    };
  },
  updateEventsDetailsErr: (err) => {
    return {
      type: actions.UPDATE_EVENTS_DETAILS_ERR,
      err,
    };
  },
  updateEventsDetailsEmpty: () => {
    return {
      type: actions.UPDATE_EVENTS_DETAILS_EMPTY,
    };
  },
};

export default actions;
